import { Formik, Form } from 'formik';
import { Button, Dialog } from 'bs-unified-ui';
import { Box } from '@mui/material';
import { createContentValidationSchema } from '~/utils/schema/content';
import { Field } from '~/components/common/Formik2';
import ContentImageUploadField from './ContentImageUploadField';

interface EditContentDialogProps {
  open: boolean;
  onClose: () => void;
  content: any;
  isLongContent: boolean;
  onSubmit: (values: any) => void;
  isLoading?: boolean;
}

const EditContentDialog = ({
  open,
  onClose,
  content,
  isLongContent,
  onSubmit,
  isLoading = false,
}: EditContentDialogProps) => {
  const initialValues = {
    image: content?.image || '',
    title: content?.title || '',
    subTitle: content?.subTitle || '',
    body: content?.body || '',
    buttonLabel: content?.buttonLabel || '',
    buttonLink: content?.buttonLink || '',
  };

  return (
    <Formik
      key={content?.id || 'new'}
      initialValues={initialValues}
      validationSchema={createContentValidationSchema(isLongContent)}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      enableReinitialize
    >
      {({ submitForm }) => (
        <Dialog
          title={content?.id ? 'Edit content' : 'Add content'}
          maxWidth={600}
          open={open}
          onClose={onClose}
          renderFooter={
            <>
              <Button variant='text' onClick={onClose} disabled={isLoading}>
                Cancel
              </Button>
              <Button onClick={submitForm} loading={isLoading} disabled={isLoading}>
                Save
              </Button>
            </>
          }
        >
          <Form>
            <Box
              sx={{
                'display': 'flex',
                'flexDirection': 'column',
                'gap': 2,
                '.MuiFormLabel-root': {
                  mb: '8px !important',
                },
              }}
            >
              {/* Image */}
              <ContentImageUploadField name='image' label='Image' />

              {/* Title */}
              <Field.Input name='title' label='Title' />

              {/* Subtitle (only for long content) */}
              {isLongContent && (
                <Field.Input name='subTitle' label='Subtitle' />
              )}

              {/* Body Text */}
              <Field.Input
                name='body'
                label='Body text'
                multiline
                rows={4}
              />

              {/* Button Label */}
              <Field.Input name='buttonLabel' label='Button label' />

              {/* Button Internal Link */}
              <Field.Input name='buttonLink' label='Button internal link' />
            </Box>
          </Form>
        </Dialog>
      )}
    </Formik>
  );
};

export default EditContentDialog;
